import { NIL } from 'uuid';

export const cpf = '000.000.000-00';

export const cnpj = '00.000.000/0000-00';

export const date = 'dd/mm/aaaa';

export const dateTime = 'dd/mm/aaaa HH:mm';

export const cellphone = '(DDD) 00000-0000';

export const email = 'email@exemplo.com';

export const uuid = NIL;
